import { RouteLocationNormalized } from 'vue-router'

export const authentication = async (to: RouteLocationNormalized, from: RouteLocationNormalized, store: any) => {
  if (to.query.token) {
    await store.dispatch('users/setToken', to.query.token)
  }

  const routeInfo = { name: 'login', from: to }

  if (!store.getters['users/getToken']) {
    return routeInfo
  }

  const loginResponse = await store.dispatch('users/login')
  if (!loginResponse && to.name !== 'login') {
    return routeInfo
  }
}
